'use client';

import React from 'react';
import AngularWrapper from '@web-app/_main/angular-wrapper';
import {
  EnhancedPasswordInputComponent,
  PasswordRulesConfig,
} from '@tremaze/enhanced-password-input';

interface EnhancedPasswordInputWrapperProps {
  value?: string;
  onChange?: (value: string | null) => void;
  placeholder?: string;
  showStrengthIndicator?: boolean;
  showToggle?: boolean;
  showRepeatPassword?: boolean;
  rules?: PasswordRulesConfig;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  color?: 'light' | 'dark' | 'white';
}

export const EnhancedPasswordInputWrapper: React.FC<
  EnhancedPasswordInputWrapperProps
> = ({
  value, // Initial value - Angular component will manage state after mount
  onChange,
  placeholder = 'Password',
  showStrengthIndicator = true,
  showToggle = true,
  showRepeatPassword = true,
  rules,
  disabled = false,
  required = false,
  className,
  color = 'white',
}) => {
  // Use ref to ensure we only set initial value once
  const initialValueRef = React.useRef(value);

  const handleValueChange = (newValue: string | null) => {
    if (onChange) {
      // Pass through the validation result (null for invalid)
      onChange(newValue);
    }
  };

  return (
    <div className={className} style={{ width: '100%' }}>
      <AngularWrapper
        component={EnhancedPasswordInputComponent}
        inputs={{
          placeholder,
          showStrengthIndicator,
          showToggle,
          showRepeatPassword,
          rules,
          disabled,
          required,
          ngModel: initialValueRef.current,
          color,
        }}
        outputs={{
          ngModelChange: handleValueChange,
        }}
      />
    </div>
  );
};
